import React, { ReactNode, useEffect, useState } from 'react';
import { useOnScreen } from '../../hooks';
import { CircularLoader } from './circular-loader';
import { Box } from '@mui/material';

interface LazyLoadSectionProps {
  children: ReactNode;
  height?: string | number;
  marginBottom?: string | number;
  rootMargin?: string;
  threshold?: number;
  placeholder?: ReactNode;
  loadOnce?: boolean;
  forceLoad?: boolean;
}

export const LazyLoadSection: React.FC<LazyLoadSectionProps> = ({
  children,
  height = 'auto',
  marginBottom = '30px',
  rootMargin = '200px',
  threshold = 0,
  placeholder,
  loadOnce = true,
  forceLoad = false,
}) => {
  const [ref, isVisible] = useOnScreen(rootMargin, threshold);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);

  useEffect(() => {
    if (isVisible && !hasBeenVisible && loadOnce) {
      setHasBeenVisible(true);
    }
  }, [isVisible, hasBeenVisible, loadOnce]);

  const shouldShowContent =
    forceLoad || (loadOnce ? hasBeenVisible : isVisible);

  return (
    <Box ref={ref} sx={{ minHeight: height, marginBottom }}>
      {shouldShowContent
        ? children
        : placeholder || (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                minHeight: height,
              }}
            >
              <CircularLoader className="circular-loader-style" />
            </Box>
          )}
    </Box>
  );
};
